<template>
  <div>
    <img src="../assets/joinus.jpg" class="img-fluid w-100" alt="joinusbanner">
    <section class="feature-area">
      <div class="mbx">
        <div class="container">
          <div class="row">
            <div class="col-lg-9">
              <div class="nytit pull-left">加入我们</div>
              <menu class="menu pull-left" id="menu">
                <!--                <div class="pull-left paddingleft15"><router-link to="/" class="cur underline " >企业动态</router-link></div>-->
                <!--                <div class="pull-left paddingleft15"><router-link to="/" class="underline text66">代理品牌动态</router-link></div>-->
                <!--                <div class="pull-left paddingleft15"><router-link to="/" class="underline text66">行业资讯</router-link></div>-->
                <!--                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_1}" @click="changeTab(0)">企业动态</a></div>-->
                <!--                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_2}" @click="changeTab(1)">代理品牌动态</a></div>-->
                <!--                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_3}" @click="changeTab(2)">行业资讯</a></div>-->
              </menu>
            </div>
            <div class="col-lg-3">
              <div class="mbxwrap">
                <router-link to="/" class="underline">首页</router-link> <span>/</span>
                <em>加入我们</em>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="feature-area paddingtop30 paddingbottom30">
      <div class="container">
        <div class="scd_r">
          <div class="r_name"><span>人才招聘</span></div>
          <div class="join">
            <div class="j_a">人才是公司发展的重要因素，人才是公司最大的财富，本公司秉承以人为本，公平、公正、公开的经营管理原则, 为员工创造一个施展才华的舞台，通过丰裕的工作内容、优越的工作环境以及和谐的工作氛围，实现企业与个人的良性互动。公司提供具有竞争力的薪酬、福利及晋升机会, 诚邀各方英才加入北京泽浩天科技发展有限公司工作团队。<br/>
              我们真诚期待你的加入！</div>
            <div class="j_b">
              <b>人事部门联络资料</b>
              <p>请有意者将个人简历、照片及学历证明复印件等相关资料发送至</p>
              <p>邮箱:<a href="mailto:zehaotian@139.com"> zehaotian@139.com</a></p>
              <p>电话: <a href="tel:010-67047381">010-67047381</a>&nbsp;&nbsp;&nbsp;&nbsp;联络人：<span>王先生</span></p>
              <b>公司目前招聘岗位如下:</b>
            </div>
            <div class="space_hx">&nbsp;</div>
            <table cellpadding="0" cellspacing="0" class="j_c">
              <tr>
                <th scope="col">职位名称</th>
                <th scope="col">招聘人数</th>
                <th scope="col">工作地点</th>
                <th scope="col">发布日期</th>
                <th scope="col">截止日期</th>
<!--                <th scope="col">&nbsp;</th>-->
              </tr>
              <tr v-for="(list,index) in recruit_info_list" :class="{rowcolor:index%2==1}">
                <td>{{list.positionNm}}</td>
                <td>{{list.recruitNum}}</td>
                <td>{{list.workplace}}</td>
                <td>{{list.releaseDate}}</td>
                <td>{{list.deadline}}</td>
<!--                <td><a href="">投送简历</a></td>-->
              </tr>
            </table>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        recruit_info_list: [],
        total: '',
      }
    },
    methods: {

      // 获取产品数据
      getRecruitInfos() {
        const vm = this;
        vm.$_axios({
          method: 'post',
          url: '/mapis/recruit/getRecruitInfos',
          data: {
          },
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            vm.recruit_info_list = responseData.recruitDtoList;
            vm.total = responseData.total;
          }
        });
      },


    },
    created() {
      let vm = this;

    },
    mounted() {
      let vm = this;
      vm.getRecruitInfos();
      // console.log('111 '+);
    }
  }
</script>




// WEBPACK FOOTER //
// JoinUs.vue?a0837772